<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      <button
        class="back-button"
        (click)="onBack()"
        [disabled]="loading"
        type="button">
        <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
      </button>

      @if (bannerVariant) {
        <lib-connection-attempt-banner
          [variant]="bannerVariant"
          [integrationEnabled]="integrationEnabled"
          [integrationEntityName]="
            integrationEntityName
          "></lib-connection-attempt-banner>
      }

      @if (!isTwoFactor) {
        <div class="header-section">
          <lib-connection-entity-brand-chip
            [displayName]="entityName"
            [iconUrl]="entityIconUrl" />

          <h1 class="step-title">
            @if (authInteraction.kind === 'SCOPE_SELECTION') {
              {{ t(scopeSelectionTitleKey, { entity: entityName }) }}
            } @else {
              {{ t('lang.auth_interaction_title_fallback') }}
            }
          </h1>

          @if (authInteraction.kind === 'SCOPE_SELECTION') {
            <p class="step-description">{{ t(scopeSelectionSubtitleKey) }}</p>
          }
        </div>
      }

      @if (isTwoFactor) {
        <lib-two-fa-code-interaction
          [authInteraction]="authInteraction"
          [endedReason]="endedReason"
          [providerName]="entityName"
          [loading]="loading"
          [resending]="resending"
          [submitError]="submitError"
          (rendererStateChange)="onTwoFaStateChange($event)"
          (submitRequested)="onSubmit()"
          (resendRequested)="
            resendRequested.emit()
          "></lib-two-fa-code-interaction>
      } @else if (authInteraction.kind === 'SCOPE_SELECTION') {
        <lib-scope-selection-interaction
          [authInteraction]="authInteraction"
          [loading]="loading"
          [lazyLoading]="lazyLoading"
          [initialDraftState]="initialDraftState"
          (rendererStateChange)="onRendererStateChange($event)"
          (pageRequested)="
            pageRequested.emit($event)
          "></lib-scope-selection-interaction>
      } @else {
        <div class="unsupported-state">
          <div class="unsupported-icon">
            <mzic-svg src="assets/icons/mzic-alert-filled.svg" />
          </div>
          <p class="unsupported-title">
            {{ t('lang.auth_interaction_unsupported_title') }}
          </p>
          <p class="unsupported-description">
            {{ t('lang.auth_interaction_unsupported_description') }}
          </p>
        </div>
      }
    </div>

    @if (footerAction; as action) {
      <div class="step-footer">
        <button
          class="primary-button"
          [disabled]="(action === 'SUBMIT' && submitDisabled()) || loading"
          (click)="onFooterAction()"
          type="button">
          @if (footerBusy) {
            <mzic-spinner />
          }
          {{ t(footerLabelKey) | uppercase }}
        </button>
      </div>
    }
  </div>
</ng-container>
